import { useState } from 'react';
import { submitUnsubscribe } from '../../api/unsubscribeApi';
import { useRecaptcha } from '../shared/useRecaptcha';
import type { UnsubscribeCampaignConfig } from '../../config/types';
import type { UnsubscribeFormValues } from './UnsubscribeFormSchema';

/** Feedback is an inline modal, not a route change — same convention as useSubscribeSubmit.ts. */
export function useUnsubscribeSubmit(config: UnsubscribeCampaignConfig) {
  const recaptcha = useRecaptcha(process.env.REACT_APP_RECAPTCHA_SITE_KEY || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);

  const onSubmit = async (values: UnsubscribeFormValues) => {
    setIsSubmitting(true);
    try {
      const recaptchaToken = await recaptcha.execute();
      const result = await submitUnsubscribe({ slug: config.slug, ...values, recaptchaToken });
      if (result.status === 'ok') {
        setSuccessOpen(true);
      } else {
        setErrorOpen(true);
      }
    } catch {
      setErrorOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return { onSubmit, isSubmitting, recaptchaRef: recaptcha.containerRef, successOpen, setSuccessOpen, errorOpen, setErrorOpen };
}
